export interface QuestionOption<T extends string> {
  value: T;
  label: string;
  description: string;
}

export interface QuestionConfig {
  key: PolicyPreferenceKey;
  title: string;
  description: string;
  options: QuestionOption<string>[];
}

export const PREFERENCE_QUESTIONS: QuestionConfig[] = [
  {
    key: 'deathBenefit',
    title: 'Do you care about death benefits?',
    description:
      'Would leaving a legacy to your children or loved ones be important to you?',
    options: [
      {
        value: 'yes',
        label: 'Yes, That Matters to Me',
        description: 'I want to leave something behind',
      },
      {
        value: 'no',
        label: 'No, Not a Priority',
        description: 'Focus on my care needs instead',
      },
    ],
  },
  {
    key: 'paymentStructure',
    title: 'How do you prefer to pay?',
    description: 'Choose the payment structure that works best for your financial situation.',
    options: [
      {
        value: 'upfront',
        label: 'Pay Everything Upfront',
        description: 'One-time lump sum payment',
      },
      {
        value: 'monthly',
        label: 'Small Monthly Premiums',
        description: 'Lower payments spread over time',
      },
      {
        value: 'balanced',
        label: 'Somewhere in the Middle',
        description: 'Balanced payment approach',
      },
      {
        value: 'noPreference',
        label: "I Don't Have a Preference",
        description: 'Show me all options',
      },
    ],
  },
  {
    key: 'benefitStructure',
    title: 'What type of benefit structure?',
    description: 'Choose between maximum value or guaranteed returns.',
    options: [
      {
        value: 'maxValue',
        label: 'Most Bang for Your Buck',
        description: 'Higher benefits, but use-it-or-lose-it',
      },
      {
        value: 'guaranteed',
        label: 'Guaranteed Benefits',
        description: 'Always get something back, even if unused',
      },
    ],
  },
];

export function getQuestionByKey(key: PolicyPreferenceKey): QuestionConfig | undefined {
  return PREFERENCE_QUESTIONS.find(q => q.key === key);
}

export function getQuestionByIndex(index: number): QuestionConfig | undefined {
  return PREFERENCE_QUESTIONS[index];
}

export const TOTAL_QUESTIONS = PREFERENCE_QUESTIONS.length;

